/**
 * Handle Nav menu and its dropdowns
 *
 * @return {void}
 */

const dropdownClass = '.js-dropdown';
const hasDropdownClass = '.js-has-dropdown';
const activeClass = 'is-active';
const openedClass = 'is-opened';
const navClass = '.js-nav';
const btnMenuClass = '.js-btn-menu';
const btnCloseClass = '.js-close-menu';
const isTabBtnClass = 'js-is-tab-btn';
const helperClass = 'overflow-hidden';
const helperClassRight = 'active-nav--right';
const helperClassLeft = 'active-nav--left';
const $body = $('body');
const $hasDropdown = $(hasDropdownClass);
const $btnMenu = $(btnMenuClass);
const $btnClose = $(btnCloseClass);

$(`${hasDropdownClass} > a:not(.view-all-link)`).on('click', function (e) {
  const $this = $(this);
  const $dropdownParent = $this.closest(hasDropdownClass);
  const $dropdown = $dropdownParent.find(`> ${dropdownClass}`);

  if (!$dropdownParent.hasClass(isTabBtnClass)) {
    e.preventDefault();
  }

  $dropdownParent.toggleClass(activeClass);
  $dropdownParent.siblings().removeClass(activeClass);
});

$(window).on('load resize', function () {
  if ($hasDropdown.length) {
    $(`${hasDropdownClass}:not(.${activeClass})`).removeClass(activeClass);
  }
});

/**
 * Tab buttons
 *
 * @param {}
 * @return {void}
 */

$(document).on('click', `.${isTabBtnClass}`, function(e) {
  e.preventDefault();

  const $this = $(this);
  const $tabElement = $this.siblings('.js-dropdown');

  if (!$tabElement.length) {
    return;
  }

  $tabElement
    .add($this.parent())
    .addClass('tab-is-active')
    .siblings('.tab-is-active')
    .removeClass('tab-is-active')
      .find('.js-dropdown')
      .removeClass('tab-is-active');
});

/**
 * Btn menu
 *
 * @return {void}
 */

$(document).on('click', btnMenuClass, function (e) {
  e.preventDefault();

  const dropdownDataHandle = $(this).attr('href');
  const $dropdownHolder = $(`[data-ddhandle="${dropdownDataHandle}"]`);
  let opensNavToRight = $(this).hasClass('js-nav-to-right');
  let opensNavToLeft = $(this).hasClass('js-nav-to-left');

  if ($dropdownHolder.length) {
    $dropdownHolder
      .addClass(openedClass)
      .siblings()
      .removeClass(openedClass);
  }

  $hasDropdown.removeClass(activeClass);

  $(navClass).toggleClass(activeClass);
  $body.toggleClass(helperClass);

  if (opensNavToLeft) {
    $body.toggleClass(helperClassLeft);
  }

  if (opensNavToRight) {
    $body.toggleClass(helperClassRight);
  }
});

/**
 * Btn Close
 *
 * @return {void}
 */

$(document).on('click', btnCloseClass, function (e) {
  e.preventDefault();

  $(hasDropdownClass).removeClass(activeClass);
  $body.removeClass(helperClassLeft).removeClass(helperClassRight).removeClass(helperClass);
  $(navClass).removeClass(activeClass);
});

/**
 * Cart drawer open
 *
 * @return {void}
 */

$(document).on('click', `${navClass} .js-drawer-cart-open`, function(e) {
  e.preventDefault();

  $body.removeClass(helperClassLeft).removeClass(helperClassRight).removeClass(helperClass);
  $(navClass).removeClass(activeClass);
});

/**
 * Close menu and dropdowns
 *
 * @return {void}
 */

$(document).on('click', function (e) {
  let target = $(e.target);

  if (!target.closest(`${btnMenuClass}, ${btnCloseClass}, ${navClass}, ${hasDropdownClass}.${activeClass}, ${hasDropdownClass} > a:not(.view-all-link)`).length) {
    $body.removeClass(helperClassLeft).removeClass(helperClassRight).removeClass(helperClass);
    $(navClass).removeClass(activeClass);
    $hasDropdown.removeClass(activeClass);
  }
});
